import axiosClient from "./axiosClient";
import {Result} from "./types";
import {getTokenCookie} from "libs";
import axios from "axios";

export class MemberApi {
    config: any

    constructor() {
        const token = getTokenCookie()
        this.config = {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }
    }

    getMemberList = async (offset: number): Promise<Result> => {
        return await axiosClient.get(`/management/member/list/${offset}`, this.config)
    }

    getBatchHistory = async (offset: number): Promise<Result> => {
        return await axiosClient.get(`/batch/history/${offset}`, this.config)
    }

    getMemberListSearch = async (offset: number, search: string): Promise<Result> => {
        return await axiosClient.get(`/management/member/search/${offset}?filter=${search}`, this.config)
    }
    getUserListSearch = async (offset: number, search: string): Promise<Result> => {
        return await axiosClient.get(`/management/user/search/${offset}?filter=${search}`, this.config)
    }
    getUserList = async (offset: number): Promise<Result> => {
        return await axiosClient.get(`/management/user/list/${offset}`, this.config)
    }
    getMemberByNim = async (nim: string): Promise<Result> => {
        return await axiosClient.get(`register/member/${nim}`)
    }
    postMemberCreate = async (data: any): Promise<Result> => {
        return await axiosClient.post(`/management/member/create`, data, this.config);
    }
    postMemberRegister = async (data: any): Promise<Result> => {
        return await axiosClient.post(`/register`, data);
    }
    postUserRegister = async (data: any): Promise<Result> => {
        return await axiosClient.post(`/management/user/create`, data, this.config);
    }

    postExcel = async (form: any): Promise<Result> => {
        const {data} = await axios.post(`/api/export`, form);
        return data;
    }
    postExcelMulti = async (form: any): Promise<Result> => {
        const {data} = await axios.post(`/api/export-m`, form);
        return data;
    }

    getProfile = async (): Promise<Result> => {
        return await axiosClient.get(`/profile/view`, this.config)
    }

    uploadProfile = async (file: any): Promise<any> => {
        const formData = new FormData();
        formData.append('file', file);
        const {data} = await axios.post(`/api/uploads/profiles`, formData, {
            headers: {
                'content-type': 'multipart/form-data'
            },
            onUploadProgress: (event) => {
                console.log(`Current progress:`, Math.round((event.loaded * 100) / event.total));
            },
        });
        return data;
    }

    importFile = async (file: any, type: string): Promise<any> => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', type);
        formData.append('token', getTokenCookie());
        const {data} = await axios.post(`/api/uploads/import`, formData, {
            headers: {
                'content-type': 'multipart/form-data'
            },
            onUploadProgress: (event) => {
                console.log(`Current progress:`, Math.round((event.loaded * 100) / event.total));
            },
        });
        return data;
    }

    postProfile = async (data: any): Promise<Result> => {
        return await axiosClient.post(`profile/profile-picture/upload/${data}`, {}, this.config);
    }

    deleteUser = async (data: any): Promise<Result> => {
        return await axiosClient.delete(`/management/user/delete/${data}`, this.config);
    }

    deleteMember = async (data: any): Promise<Result> => {
        return await axiosClient.delete(`/management/member/delete/${data}`, this.config);
    }
}
